<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents">
                    <div class="title">
                        오늘 배너 수정
                        <div class="clear"></div>
                    </div>
                    <today-banner-write-component :todayBannerType="'updateTodayBanner'" :todayBannerKey="todayBannerKey"></today-banner-write-component>
                    <div class="mt15 text_center">
                        <el-button @click="$modal.show('banner-delete-modal')" type="danger">삭제</el-button>
                        <el-button @click="submitForm()" type="primary">저장</el-button>
                    </div>
                </div>
                <page-footer></page-footer>
            </div>
        </div>
        <banner-delete-modal :todayBannerKey="todayBannerKey"></banner-delete-modal>
    </div>
</template>

<script>
import TodayBannerWriteComponent from "@/components/todayBanner/TodayBannerWriteComponent";
import EventBus from "@/mixins/event-bus";
import BannerDeleteModal from "@/components/modal/BannerDeleteModal";

export default {
    name: "TodayBannerDetail",
    mixins: [],
    components: {BannerDeleteModal, TodayBannerWriteComponent},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            todayBannerKey: this.$route.params.b_idx,
        }
    },
    beforeRouterEnter() {},
    created() {},
    mounted() {},
    beforeDestroy() {},
    destroyed() {
    },
    computed: {},
    methods: {
        submitForm() {
            EventBus.$emit('writeTodayBanner');
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>